/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetDocumentFileParams
} from '../../model';

import { instance } from '../../index';
import type { ErrorType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocumentFile = (
    publicId: string,
    params?: GetDocumentFileParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<Blob>(
      {url: `/api/v1/documents/${publicId}/file`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetDocumentFileQueryKey = (publicId: string,
    params?: GetDocumentFileParams,) => {
    return [`/api/v1/documents/${publicId}/file`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentFileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentFile>>, GetDocumentFileParams['page']>, TError = ErrorType<unknown>>(publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentFileQueryKey(publicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']> = ({ signal, pageParam }) => getDocumentFile(publicId,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentFile>>>
export type GetDocumentFileInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentFile>>, GetDocumentFileParams['page']>, TError = ErrorType<unknown>>(
 publicId: string,
    params: undefined |  GetDocumentFileParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentFile>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentFile>>, GetDocumentFileParams['page']>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentFile>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentFile>>, GetDocumentFileParams['page']>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentFileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentFile>>, GetDocumentFileParams['page']>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData, Awaited<ReturnType<typeof getDocumentFile>>, QueryKey, GetDocumentFileParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentFileInfiniteQueryOptions(publicId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentFileQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentFileQueryKey(publicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentFile>>> = ({ signal }) => getDocumentFile(publicId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentFileQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentFile>>>
export type GetDocumentFileQueryError = ErrorType<unknown>


export function useGetDocumentFile<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params: undefined |  GetDocumentFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFile<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getDocumentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFile<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentFile<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentFileQueryOptions(publicId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentFileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentFileQueryKey(publicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentFile>>> = ({ signal }) => getDocumentFile(publicId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentFileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentFile>>>
export type GetDocumentFileSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentFileSuspense<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params: undefined |  GetDocumentFileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFileSuspense<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentFileSuspense<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentFileSuspense<TData = Awaited<ReturnType<typeof getDocumentFile>>, TError = ErrorType<unknown>>(
 publicId: string,
    params?: GetDocumentFileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentFileSuspenseQueryOptions(publicId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



